import { useState } from "react";
import "./LandingPage.css";

const features = [
  {
    icon: "🧳",
    title: "Create Trips",
    description:
      "Plan any adventure — a weekend getaway or a month-long journey. Set your dates and go.",
  },
  {
    icon: "📅",
    title: "Build Events",
    description:
      "Add activities to your trip and attach exactly what you'll need for each one.",
  },
  {
    icon: "📋",
    title: "Instant Packing Lists",
    description:
      "Get a smart packing list auto-generated by day and bag. Never forget a thing.",
  },
];

const LandingPage = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setSubmitted(true);
    }
  };

  return (
    <div className="landing-container">
      {/* Navbar */}
      <nav className="landing-nav">
        <div className="nav-brand">
          <img src="/packityrat.png" alt="Pack Rat logo" className="nav-logo" />
          <span className="nav-wordmark">Pack Rat</span>
        </div>
      </nav>

      {/* Hero */}
      <section className="landing-hero">
        <div className="hero-logo">
          <img src="/packityrat.png" alt="Pack Rat mascot" />
        </div>
        <h1>Pack Rat</h1>
        <p className="tagline">
          Organize your packing by trip, day, and event.
        </p>
        <span className="coming-soon-badge">Coming Soon</span>

        {submitted ? (
          <p className="waitlist-success">You're on the list!</p>
        ) : (
          <form className="waitlist-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              aria-label="Email address"
            />
            <button type="submit" className="btn-notify">
              Notify Me
            </button>
          </form>
        )}
      </section>

      {/* Features */}
      <section className="features-section">
        <h2 className="features-heading">Everything you need to pack smarter</h2>
        <div className="features-grid">
          {features.map(({ icon, title, description }) => (
            <div key={title} className="feature-card">
              <span className="feature-icon">{icon}</span>
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <p>© 2025 Pack Rat</p>
      </footer>
    </div>
  );
};

export default LandingPage;
